/**
 * Converte HTML prodotto dall'editor TipTap (StarterKit) in plain text adatto
 * al campo `description` degli eventi Google Calendar.
 *
 * Google Calendar non interpreta HTML nel campo description: mostra i tag
 * grezzi. Questa funzione preserva le interruzioni di riga e rimuove il
 * markup.
 */
export function htmlToCalendarText(html: string | null | undefined): string {
  if (!html) return '';

  let text = html;

  // Sostituisci i tag che rappresentano interruzioni di riga con \n
  text = text.replace(/<br\s*\/?>/gi, '\n');
  text = text.replace(/<\/(p|div|li|h[1-6])>/gi, '\n');
  // Prepend newline per gli elementi di lista in modo da separarli
  text = text.replace(/<li[^>]*>/gi, '- ');

  // Rimuovi tutti gli altri tag
  text = text.replace(/<[^>]+>/g, '');

  // Decodifica le entità HTML più comuni
  text = text
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");

  // Collassa spazi multipli all'interno della stessa riga e rimuovi
  // righe vuote eccessive, mantenendo al massimo una riga vuota.
  text = text
    .split('\n')
    .map(line => line.replace(/[ \t]+/g, ' ').trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  return text;
}
